import { Redirect } from 'expo-router'
import type { ReactNode } from 'react'

import { useWatchmanPrayFlow } from '@/src/features/intention/ui/hooks/useWatchmanPrayFlow'
import { useBackHandlePress } from '@/src/general/hooks/useBackHandlePress'
import { useRoutes } from '@/src/general/utils/routes'

import { WatchmanPrayFlowBase } from './WatchmanPrayFlowBase'

export const WatchmanPrayFlow = (): ReactNode => {
  const { routes } = useRoutes()
  const { handleBackPress } = useBackHandlePress(routes.watchmanIntentions())

  const { intentions, isLoading, next, pray, screenIndex, step, toIntentionPrayerIds } = useWatchmanPrayFlow()

  const hasIntentions = !!intentions?.length

  if (!isLoading && hasIntentions && step > intentions.length) {
    return <Redirect href={routes.watchmanIntentionsReward()} />
  }

  if (!isLoading && !hasIntentions) return <Redirect href={routes.intentions()} />

  const handleConfirmClose = () => handleBackPress()

  return (
    <WatchmanPrayFlowBase
      intentions={intentions}
      isLoading={isLoading}
      next={next}
      pray={pray}
      screenIndex={screenIndex}
      step={step}
      toIntentionPrayerIds={toIntentionPrayerIds}
      onConfirmClose={handleConfirmClose}
    />
  )
}
